import * as React from "react";
import { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { useParams } from "react-router-dom";
import { InputAdornment, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Divider from "@material-ui/core/Divider";
import Card from "@material-ui/core/Card";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import GetCurrency from "../../../helper/GetCurrency";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from "react-toastify";
import { _post } from "../../../Api";
import _ from "lodash";
import CircularProgress from "@material-ui/core/CircularProgress";

export const ta_periods = ["MONTHLY", "WEEKLY", "YEARLY"];
export const ta_invoice_types = ["BOOKING", "INCASSO", "PAYNL"];

export default function TAmountSubscriptions(props) {
  const [TAmountSubscriptions, setTAmountSubscriptions] = React.useState(null);
  const [editTAmountSubscriptions, setEditTAmountSubscriptions] = React.useState(null);
  const editable = props.editable;
  const merchantId = parseInt(useParams().merchantId);
  const merchant_type = props.merchantType;
  const toast_values = {
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const openAddDialog = () => props.setAddDialogType(merchant_type.toLowerCase());

  const openRemoveDialog = (id) => {
    props.setSelectedSubscription(id);
    props.setRemoveDialogType(merchant_type.toLowerCase());
  };

  const warning_triggered = (key, new_sub) => {
    if (key === "meta amount_price" && new_sub["amount_price"] < 0.01) {
      toast.error("The price cannot be zero or a negative number.", toast_values);
      return true;
    }
    if (
      new_sub["subscription_stopped"] &&
      new Date(new_sub["subscription_started"]) > new Date(new_sub["subscription_stopped"])
    ) {
      toast.error("End date has to be later than start date", toast_values);
      return true;
    }
  };

  const initializeTASubscriptions = () => {
    const subs = props.subscriptions.filter((sub) => sub.type === merchant_type);
    subs.map((sub) => {
      if (sub["meta"]["vat"] && sub["meta"]["vat"] < 1) {
        return (sub["meta"]["vat"] *= 100);
      } else if (sub["meta"]["vat"] == null) {
        return "";
      } else {
        return sub["meta"]["vat"];
      }
    });
    setTAmountSubscriptions(_.cloneDeep(subs));
    setEditTAmountSubscriptions(_.cloneDeep(subs));
  };
  useEffect(initializeTASubscriptions, []);

  const postTAmountSubscriptions = (id, key, value = null) => {
    const mapping = {
      T: "ta_merchant_id",
      S: "sp_merchant_id",
      P: "pillar_merchant_id",
    };
    const oldsub = TAmountSubscriptions.find((sub) => sub.id === id);
    const newsub = editTAmountSubscriptions.find((sub) => sub.id === id);
    let data;
    let equal = key.includes("meta")
      ? oldsub["meta"][key.replace("meta ", "")] === newsub["meta"][key.replace("meta ", "")]
      : oldsub[key] === newsub[key];
    if (key === "merchant_id") {
      equal = oldsub[mapping[value[0]]] === newsub[mapping[value[0]]];
      data = {
        [mapping[value[0]]]: parseInt(newsub[mapping[value[0]]]),
      };
    } else if (key.includes("vat")) {
      data = {
        vat: newsub["meta"][key.replace("meta ", "")] / 100,
      };
    } else if (key.includes("meta")) {
      data = {
        [key.replace("meta ", "")]: newsub["meta"][key.replace("meta ", "")],
      };
    } else {
      data = {
        [key]: newsub[key],
      };
    }
    if (equal || warning_triggered(key, newsub)) {
      return;
    }

    _post("/nova/merchant/" + merchantId + "/subscription/" + id, data)
      .then(() => {
        toast.success(`Saved ${merchant_type} subscriptions successfully!`, toast_values);
        setTAmountSubscriptions(editTAmountSubscriptions);
      })
      .catch((error) => {
        console.log(error);
        toast.error(`${merchant_type} subscriptions could not be saved.`, toast_values);
      });
  };

  const changeTAmountSubscriptions = (id, key, value) => {
    if (id == null || props.paymentMode || editTAmountSubscriptions == null) return;
    const mapping = {
      T: "ta_merchant_id",
      S: "sp_merchant_id",
      P: "pillar_merchant_id",
    };
    const subs = _.cloneDeep(editTAmountSubscriptions);
    const currentSub = subs.findIndex((sub) => sub.id === id);
    if (key === "wefact_merchant") {
      subs[currentSub]["wefact_merchant"] = props.wefactMerchants.find((merchant) => merchant.id === value);
    } else if (key.includes("meta")) {
      subs[currentSub]["meta"][key.replace("meta ", "")] = value;
    } else if (key === "merchant_id") {
      subs[currentSub][mapping[value[0]]] = value.slice(1);
      if (mapping[value[0]] === "ta_merchant_id") {
        delete subs[currentSub]["sp_merchant_id"];
        delete subs[currentSub]["pillar_merchant_id"];
      } else if (mapping[value[0]] === "sp_merchant_id") {
        delete subs[currentSub]["ta_merchant_id"];
        delete subs[currentSub]["pillar_merchant_id"];
      } else if (mapping[value[0]] === "pillar_merchant_id") {
        delete subs[currentSub]["ta_merchant_id"];
        delete subs[currentSub]["sp_merchant_id"];
      }
    } else {
      subs[currentSub][key] = value;
    }
    setEditTAmountSubscriptions(subs);
  };

  if (
    merchant_type == null ||
    props.subscriptions == null ||
    editTAmountSubscriptions == null ||
    props.wefactMerchants == null
  ) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Grid container direction="column" spacing={4}>
      <Grid container direction="row" spacing={2} style={{ marginTop: "20px" }}>
        <Grid item>
          <Typography variant={"h5"}>{merchant_type}</Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            disabled={!editable}
            onClick={openAddDialog}
            startIcon={<AddIcon />}
            color="primary"
          >
            Subscription
          </Button>
        </Grid>
      </Grid>
      <Divider style={{ margin: "20px 0" }} />
      {editTAmountSubscriptions.map((subscription) => {
        if (editable) {
          return (
            <Grid item key={subscription.id}>
              <Card style={{ padding: "1em" }}>
                <Grid container direction={"row"} spacing={3}>
                  <Grid item>
                    <FormControl>
                      <InputLabel>debtor</InputLabel>
                      <Select
                        value={subscription.wefact_merchant_id}
                        onBlur={() => postTAmountSubscriptions(subscription.id, "wefact_merchant")}
                        onChange={(event) =>
                          changeTAmountSubscriptions(subscription.id, "wefact_merchant", event.target.value)
                        }
                      >
                        {props.wefactMerchants.map((merchant) => {
                          return <MenuItem value={merchant.id}>{merchant.debtor_code + " " + merchant.name}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    {(() => {
                      if (merchant_type.includes("TA")) {
                        return (
                          <FormControl>
                            <InputLabel>merchant</InputLabel>
                            <Select
                              value={subscription.ta_merchant_id}
                              onChange={(event) =>
                                changeTAmountSubscriptions(subscription.id, "ta_merchant_id", event.target.value)
                              }
                            >
                              {props.merchant.ta_merchants.map((ta_merchant) => {
                                return <MenuItem value={ta_merchant.id}>{"T" + ta_merchant.id}</MenuItem>;
                              })}
                            </Select>
                          </FormControl>
                        );
                      }
                      if (merchant_type.includes("SP")) {
                        return (
                          <FormControl>
                            <InputLabel>merchant</InputLabel>
                            <Select
                              value={subscription.sp_merchant_id}
                              onChange={(event) =>
                                changeTAmountSubscriptions(subscription.id, "sp_merchant_id", event.target.value)
                              }
                            >
                              {props.merchant.sp_merchants.map((sp_merchant) => {
                                return <MenuItem value={sp_merchant.id}>{"S" + sp_merchant.id}</MenuItem>;
                              })}
                            </Select>
                          </FormControl>
                        );
                      }
                      const merchant_ids = [
                        subscription.ta_merchant_id,
                        subscription.sp_merchant_id,
                        subscription.pillar_merchant_id,
                      ];
                      const merchant_id_values = [
                        "T" + subscription.ta_merchant_id,
                        "S" + subscription.sp_merchant_id,
                        "P" + subscription.pillar_merchant_id,
                      ];
                      const tam = props.merchant.ta_merchants
                        ? props.merchant.ta_merchants.map((merchant) => "T" + merchant.id)
                        : [];
                      const spm = props.merchant.sp_merchants
                        ? props.merchant.sp_merchants.map((merchant) => "S" + merchant.id)
                        : [];
                      const pillarm = props.merchant.pillar_merchants
                        ? props.merchant.pillar_merchants.map((merchant) => "P" + merchant.id)
                        : [];
                      const merchants = [...tam, ...spm, ...pillarm];
                      const id_index = merchant_ids.findIndex((id) => id);
                      return (
                        <FormControl>
                          <InputLabel>merchant</InputLabel>
                          <Select
                            value={merchant_id_values[id_index]}
                            onChange={(event) =>
                              changeTAmountSubscriptions(subscription.id, "merchant_id", event.target.value)
                            }
                            onBlur={(event) =>
                              postTAmountSubscriptions(subscription.id, "merchant_id", event.target.value)
                            }
                          >
                            {merchants.map((merchant) => {
                              return <MenuItem value={merchant}>{merchant}</MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                      );
                    })()}
                  </Grid>
                  <Grid item>
                    <TextField
                      label="title"
                      value={subscription.name}
                      onBlur={() => postTAmountSubscriptions(subscription.id, "name")}
                      onChange={(event) => changeTAmountSubscriptions(subscription.id, "name", event.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="start date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changeTAmountSubscriptions(subscription.id, "subscription_started", event.target.value)
                      }
                      onBlur={() => postTAmountSubscriptions(subscription.id, "subscription_started")}
                      value={(() => {
                        const index = subscription.subscription_started.indexOf("T");
                        return index > -1
                          ? subscription.subscription_started.slice(0, index)
                          : subscription.subscription_started;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="end date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changeTAmountSubscriptions(subscription.id, "subscription_stopped", event.target.value)
                      }
                      onBlur={() => postTAmountSubscriptions(subscription.id, "subscription_stopped")}
                      value={(() => {
                        if (subscription.subscription_stopped == null) return "";
                        const index = subscription.subscription_stopped.indexOf("T");
                        return index > -1
                          ? subscription.subscription_stopped.slice(0, index)
                          : subscription.subscription_stopped;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <FormControl>
                      <InputLabel>period</InputLabel>
                      <Select
                        value={subscription.period}
                        onBlur={() => postTAmountSubscriptions(subscription.id, "period")}
                        onChange={(event) => changeTAmountSubscriptions(subscription.id, "period", event.target.value)}
                      >
                        {ta_periods.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl>
                      <InputLabel>invoice type</InputLabel>
                      <Select
                        value={subscription.invoice_type}
                        onBlur={() => postTAmountSubscriptions(subscription.id, "invoice_type")}
                        onChange={(event) =>
                          changeTAmountSubscriptions(subscription.id, "invoice_type", event.target.value)
                        }
                      >
                        {ta_invoice_types.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  {(() => {
                    if (merchant_type.includes("TA") || merchant_type.includes("SP")) {
                      return (
                        <Grid item>
                          <FormControl variant="outlined">
                            <InputLabel>amount price</InputLabel>
                            <OutlinedInput
                              type="number"
                              inputMode="decimal"
                              startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                              labelWidth={60}
                              onBlur={() => postTAmountSubscriptions(subscription.id, "meta amount_price")}
                              onChange={(event) =>
                                changeTAmountSubscriptions(
                                  subscription.id,
                                  "meta amount_price",
                                  event.target.value ? parseFloat(event.target.value) : null
                                )
                              }
                              value={subscription.meta.amount_price}
                              inputProps={{
                                min: 0,
                                step: 0.01,
                              }}
                            />
                          </FormControl>
                        </Grid>
                      );
                    }
                  })()}
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel>VAT</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="numeric"
                        endAdornment={<InputAdornment position="end">{"%"}</InputAdornment>}
                        labelWidth={33}
                        onBlur={() => postTAmountSubscriptions(subscription.id, "meta vat")}
                        onChange={(event) =>
                          changeTAmountSubscriptions(
                            subscription.id,
                            "meta vat",
                            event.target.value ? parseInt(event.target.value) : null
                          )
                        }
                        value={subscription.meta.vat}
                        inputProps={{
                          min: 0,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        changeTAmountSubscriptions(subscription.id, "subscription_stopped", null);
                      }}
                      onBlur={() => {
                        postTAmountSubscriptions(subscription.id, "subscription_stopped");
                      }}
                    >
                      Empty end date
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button startIcon={<DeleteIcon />} onClick={() => openRemoveDialog(subscription.id)} />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          );
        } else {
          return (
            <Grid item key={subscription.id}>
              <Card style={{ padding: "1em" }}>
                <Grid container direction={"row"} spacing={3}>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>debtor</InputLabel>
                      <Select
                        value={subscription.wefact_merchant_id}
                        onBlur={() => postTAmountSubscriptions(subscription.id, "wefact_merchant")}
                        onChange={(event) =>
                          changeTAmountSubscriptions(subscription.id, "wefact_merchant", event.target.value)
                        }
                      >
                        {props.wefactMerchants.map((merchant) => {
                          return <MenuItem value={merchant.id}>{merchant.debtor_code + " " + merchant.name}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    {(() => {
                      if (merchant_type.includes("TA")) {
                        return (
                          <FormControl disabled>
                            <InputLabel>merchant</InputLabel>
                            <Select
                              value={subscription.ta_merchant_id}
                              onChange={(event) =>
                                changeTAmountSubscriptions(subscription.id, "ta_merchant_id", event.target.value)
                              }
                            >
                              {props.merchant.ta_merchants.map((ta_merchant) => {
                                return <MenuItem value={ta_merchant.id}>{"T" + ta_merchant.id}</MenuItem>;
                              })}
                            </Select>
                          </FormControl>
                        );
                      }
                      if (merchant_type.includes("SP")) {
                        return (
                          <FormControl disabled>
                            <InputLabel>merchant</InputLabel>
                            <Select
                              value={subscription.sp_merchant_id}
                              onChange={(event) =>
                                changeTAmountSubscriptions(subscription.id, "sp_merchant_id", event.target.value)
                              }
                            >
                              {props.merchant.sp_merchants.map((sp_merchant) => {
                                return <MenuItem value={sp_merchant.id}>{"S" + sp_merchant.id}</MenuItem>;
                              })}
                            </Select>
                          </FormControl>
                        );
                      }
                      const merchant_ids = [
                        subscription.ta_merchant_id,
                        subscription.sp_merchant_id,
                        subscription.pillar_merchant_id,
                      ];
                      const merchant_id_values = [
                        "T" + subscription.ta_merchant_id,
                        "S" + subscription.sp_merchant_id,
                        "P" + subscription.pillar_merchant_id,
                      ];
                      const tam = props.merchant.ta_merchants
                        ? props.merchant.ta_merchants.map((merchant) => "T" + merchant.id)
                        : [];
                      const spm = props.merchant.sp_merchants
                        ? props.merchant.sp_merchants.map((merchant) => "S" + merchant.id)
                        : [];
                      const pillarm = props.merchant.pillar_merchants
                        ? props.merchant.pillar_merchants.map((merchant) => "P" + merchant.id)
                        : [];
                      const merchants = [...tam, ...spm, ...pillarm];
                      const id_index = merchant_ids.findIndex((id) => id);
                      return (
                        <FormControl disabled>
                          <InputLabel>merchant</InputLabel>
                          <Select
                            value={merchant_id_values[id_index]}
                            onChange={(event) =>
                              changeTAmountSubscriptions(subscription.id, "merchant_id", event.target.value)
                            }
                            onBlur={(event) =>
                              postTAmountSubscriptions(subscription.id, "merchant_id", event.target.value)
                            }
                          >
                            {merchants.map((merchant) => {
                              return <MenuItem value={merchant}>{merchant}</MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                      );
                    })()}
                  </Grid>
                  <Grid item>
                    <TextField
                      label="title"
                      value={subscription.name}
                      disabled
                      onBlur={() => postTAmountSubscriptions(subscription.id, "name")}
                      onChange={(event) => changeTAmountSubscriptions(subscription.id, "name", event.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="start date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      onChange={(event) =>
                        changeTAmountSubscriptions(subscription.id, "subscription_started", event.target.value)
                      }
                      onBlur={() => postTAmountSubscriptions(subscription.id, "subscription_started")}
                      value={(() => {
                        const index = subscription.subscription_started.indexOf("T");
                        return index > -1
                          ? subscription.subscription_started.slice(0, index)
                          : subscription.subscription_started;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="end date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      onChange={(event) =>
                        changeTAmountSubscriptions(subscription.id, "subscription_stopped", event.target.value)
                      }
                      onBlur={() => postTAmountSubscriptions(subscription.id, "subscription_stopped")}
                      value={(() => {
                        if (subscription.subscription_stopped == null) return "";
                        const index = subscription.subscription_stopped.indexOf("T");
                        return index > -1
                          ? subscription.subscription_stopped.slice(0, index)
                          : subscription.subscription_stopped;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>period</InputLabel>
                      <Select
                        value={subscription.period}
                        onBlur={() => postTAmountSubscriptions(subscription.id, "period")}
                        onChange={(event) => changeTAmountSubscriptions(subscription.id, "period", event.target.value)}
                      >
                        {ta_periods.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>invoice type</InputLabel>
                      <Select
                        value={subscription.invoice_type}
                        onBlur={() => postTAmountSubscriptions(subscription.id, "invoice_type")}
                        onChange={(event) =>
                          changeTAmountSubscriptions(subscription.id, "invoice_type", event.target.value)
                        }
                      >
                        {ta_invoice_types.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  {(() => {
                    if (merchant_type.includes("TA") || merchant_type.includes("SP")) {
                      return (
                        <Grid item>
                          <FormControl disabled variant="outlined">
                            <InputLabel>amount price</InputLabel>
                            <OutlinedInput
                              type="number"
                              inputMode="decimal"
                              startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                              disabled
                              labelWidth={60}
                              onBlur={() => postTAmountSubscriptions(subscription.id, "meta amount_price")}
                              onChange={(event) =>
                                changeTAmountSubscriptions(
                                  subscription.id,
                                  "meta amount_price",
                                  event.target.value ? parseFloat(event.target.value) : null
                                )
                              }
                              value={subscription.meta.amount_price}
                              inputProps={{
                                min: 0,
                                step: 0.01,
                              }}
                            />
                          </FormControl>
                        </Grid>
                      );
                    }
                  })()}
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel>VAT</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="numeric"
                        endAdornment={<InputAdornment position="end">{"%"}</InputAdornment>}
                        labelWidth={33}
                        disabled
                        onBlur={() => postTAmountSubscriptions(subscription.id, "meta vat")}
                        onChange={(event) =>
                          changeTAmountSubscriptions(
                            subscription.id,
                            "meta vat",
                            event.target.value ? parseInt(event.target.value) : null
                          )
                        }
                        value={subscription.meta.vat}
                        inputProps={{
                          min: 0,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      disabled
                      onClick={() => {
                        changeTAmountSubscriptions(subscription.id, "subscription_stopped", null);
                      }}
                      onBlur={() => {
                        postTAmountSubscriptions(subscription.id, "subscription_stopped");
                      }}
                    >
                      Empty end date
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button startIcon={<DeleteIcon />} disabled onClick={() => openRemoveDialog(subscription.id)} />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          );
        }
      })}
    </Grid>
  );
}
